import { throttle } from 'throttle-debounce';
import { addEvent } from '../global/eventBus';

const MOBILE_BREAKPOINT = 768;

/**
 * Applies video src depending on what device we're using
 */
const setVideoSrc = (): void => {
  const els = document.querySelectorAll('[data-content-video]');
  if (els.length <= 0) return;

  els.forEach((video: HTMLVideoElement) => {
    const sourceMp4: HTMLSourceElement = video.querySelector('source[type="video/mp4"]');

    const videoMp4 = video.dataset.videoMp4;
    const videoMp4Mob = video.dataset.videoMp4Mob;

    let changed = false;

    if (window.innerWidth > MOBILE_BREAKPOINT && video.dataset.mode !== 'dt') {
      video.dataset.mode = 'dt';
      changed = true;
    } else if (window.innerWidth <= MOBILE_BREAKPOINT && video.dataset.mode !== 'mob') {
      video.dataset.mode = 'mob';
      changed = true;
    }

    if (changed) {
      if (videoMp4 || videoMp4Mob) {
        sourceMp4.setAttribute('type', 'video/mp4');
        sourceMp4.setAttribute('src', window.innerWidth > MOBILE_BREAKPOINT ? videoMp4 : videoMp4Mob);
      }

      video.load();
      video.play();
    }
  });
}

/**
 * 
 */
const initResponsiveVideo = (): void => {
  setVideoSrc();
  window.addEventListener('resize', throttle(250, false, () => setVideoSrc()));
}

const initVideoModal = (): void => {
  const heroVideo: HTMLVideoElement = document.querySelector('[data-hero-video]');
  if (!heroVideo) return;

  addEvent('modalopen', () => {
    heroVideo.play();
  });
  addEvent('modalclose', () => heroVideo.pause());
}

export {
  initResponsiveVideo,
  initVideoModal
};